import { sheetSize } from './geometry.js';
/**
 * Gemeinsame Darstellung der Felder. Editor, Druckansicht und PDF-Dienst
 * binden denselben Stil ein, damit auf dem Papier steht, was im Editor zu
 * sehen ist.
 */
export const FIELD_CSS = `
.ab-sheet {
  position: relative;
  background: #fff;
  box-sizing: border-box;
}

.ab-sheet * {
  box-sizing: border-box;
}

.ab-field {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.ab-text,
.ab-bubble-text,
.ab-lined-text,
.ab-table {
  line-height: 1.3;
  overflow-wrap: break-word;
  hyphens: auto;
}

.ab-paragraph {
  margin: 0;
}

.ab-list {
  margin: 0;
  padding-inline-start: 6mm;
}

.ab-text {
  position: relative;
}

.ab-text-body {
  position: relative;
}

.ab-line-numbers {
  position: absolute;
  left: 0;
  top: 0;
  width: 7mm;
  height: 100%;
  font-family: system-ui, sans-serif;
  font-size: 8pt;
  line-height: 1;
  color: #6b7280;
}

.ab-line-numbers span {
  position: absolute;
  right: 1.5mm;
  /* Die Nummer sitzt an der Oberkante ihrer Zeile. */
  transform: translateY(0.3em);
}

.ab-text:has(.ab-line-numbers) .ab-text-body {
  margin-inline-start: 8mm;
}

.ab-gap {
  border-bottom: 0.3mm solid currentColor;
  min-width: 10mm;
}

.ab-gap-filled {
  border-bottom: 0.3mm solid currentColor;
}

.ab-numbering {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.ab-bubble,
.ab-lined,
.ab-shape,
.ab-grid {
  position: relative;
}

.ab-bubble > svg,
.ab-lined > svg,
.ab-shape > svg,
.ab-grid > svg {
  position: absolute;
  inset: 0;
}

.ab-bubble-text,
.ab-lined-text {
  position: absolute;
  inset: 0;
}

.ab-baseline-probe {
  display: inline-block;
  width: 0;
  height: 0;
  vertical-align: baseline;
}

.ab-image img {
  display: block;
}

.ab-image-missing,
.ab-pending-edit span {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  font-family: system-ui, sans-serif;
  font-size: 9pt;
  color: #6b7280;
}

.ab-pending-edit {
  border: 0.3mm dashed #9aa3b2;
  background: #f6f8fc;
}

/* --- QR, Link und Vorlesen (Phase 7.4/7.5) --- */

.ab-qr {
  position: relative;
  width: 100%;
  height: 100%;
}

.ab-qr svg {
  width: 100%;
  height: 100%;
}

.ab-qr-frame {
  position: absolute;
  inset: 0;
  border-style: solid;
}

.ab-link {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  text-decoration: underline;
}

.ab-audio {
  display: flex;
  align-items: center;
  gap: 1.5mm;
  width: 100%;
  height: 100%;
}

.ab-audio-invisible {
  border: 0.3mm dashed transparent;
}

.ab-audio-icon {
  font-size: 1.4em;
  line-height: 1;
}

/* --- Differenzierung (Phase 8.2) --- */

.ab-level-mark {
  position: absolute;
  top: -1mm;
  right: -1mm;
  font-size: 0.7em;
  color: #6b7280;
  letter-spacing: -0.1em;
}

/* --- Neue Formate (Phase 8.2) --- */

.ab-places th,
.ab-places td {
  min-width: 8mm;
}

.ab-money-row,
.ab-baseten-row,
.ab-truefalse-row,
.ab-choice-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 2mm;
  margin: 0 0 1.5mm;
}

.ab-money-pieces {
  display: flex;
  flex-wrap: wrap;
  gap: 1mm;
}

.ab-coin,
.ab-note {
  padding: 0.2mm 1.4mm;
  border: 0.3mm solid currentColor;
  font-size: 0.8em;
}

.ab-coin {
  border-radius: 50%;
}

.ab-note {
  border-radius: 1mm;
}

.ab-baseten-blocks {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 0.8mm;
}

.ab-block {
  display: inline-block;
  border: 0.25mm solid currentColor;
}

.ab-block-ones {
  width: 1.6mm;
  height: 1.6mm;
}

.ab-block-tens {
  width: 1.6mm;
  height: 16mm;
}

.ab-block-hundreds {
  width: 16mm;
  height: 16mm;
}

.ab-block-thousands {
  width: 16mm;
  height: 16mm;
  background: repeating-linear-gradient(45deg, currentColor 0 0.4mm, transparent 0.4mm 2mm);
}

.ab-box {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 4.5mm;
  height: 4.5mm;
  border: 0.3mm solid currentColor;
  margin-right: 0.8mm;
}

.ab-choice-boxes,
.ab-choice-option {
  display: inline-flex;
  align-items: center;
  gap: 0.6mm;
}

.ab-choice-option {
  margin-right: 3mm;
}

.ab-choice-question {
  min-width: 18mm;
}

.ab-matching {
  display: grid;
  grid-template-columns: 1fr 14mm 1fr;
  align-items: stretch;
  width: 100%;
  height: 100%;
}

.ab-matching-side {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin: 0;
  padding: 0;
  list-style: none;
}

.ab-matching-lines {
  width: 100%;
  height: 100%;
}

.ab-crossword {
  display: flex;
  flex-direction: column;
  gap: 1.5mm;
}

.ab-crossword-grid {
  display: grid;
  gap: 0;
}

.ab-crossword-cell {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  aspect-ratio: 1;
  border: 0.25mm solid currentColor;
  font-size: 0.8em;
}

.ab-crossword-cell.is-empty {
  border: none;
}

.ab-crossword-number {
  position: absolute;
  top: 0;
  left: 0.3mm;
  font-size: 0.5em;
}

.ab-crossword-clues {
  margin: 0;
  padding-left: 5mm;
  font-size: 0.8em;
}

.ab-syllable-cards {
  display: flex;
  flex-wrap: wrap;
  gap: 1.2mm;
  margin: 0 0 2mm;
}

.ab-syllable-card {
  padding: 0.4mm 1.6mm;
  border: 0.3mm solid currentColor;
  border-radius: 1mm;
}

.ab-syllable-words {
  margin: 0;
  padding-left: 5mm;
}

.ab-syllable-words li {
  border-bottom: 0.25mm solid currentColor;
  margin-bottom: 1.5mm;
}

.ab-phonics {
  display: grid;
  gap: 0.6mm;
  width: 100%;
}

.ab-phonics-cell {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0.6mm;
  border: 0.25mm solid currentColor;
  font-size: 0.7em;
}

.ab-pictogram {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  /* Die Beschriftung darf über den Rand hinausragen, damit sie lesbar bleibt. */
  overflow: visible;
}

.ab-pictogram svg {
  flex: 1;
  width: 100%;
  min-height: 0;
}

.ab-pictogram-label {
  font-size: 0.6em;
  line-height: 1.1;
  white-space: nowrap;
}

/* --- Diagramm und Formel (Phase 8.1) --- */

.ab-chart {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}

.ab-chart svg {
  flex: 1;
  width: 100%;
}

.ab-chart-legend {
  display: flex;
  flex-wrap: wrap;
  gap: 1mm 3mm;
  margin: 0;
  padding: 0;
  list-style: none;
  font-size: 0.8em;
}

.ab-chart-legend li {
  display: flex;
  align-items: center;
  gap: 1mm;
}

.ab-chart-swatch {
  width: 3mm;
  height: 3mm;
  border-radius: 1px;
}

.ab-formula {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

/* --- Weitere Mathematikfelder (Phase 8.1) --- */

.ab-magic {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1mm;
}

.ab-magic-sum {
  margin: 0;
  font-size: 0.85em;
}

.ab-operator,
.ab-wheel {
  width: 100%;
  height: 100%;
}

.ab-malgrid .ab-sum,
.ab-malgrid .ab-sum-head {
  background: #f1f3f7;
}

.ab-malgrid .ab-check {
  background: #e3e9f4;
  font-weight: 600;
}

.ab-geoboard {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
}

.ab-geoboard svg {
  flex: 1;
  width: 100%;
}

.ab-geoboard-answer {
  margin: 0;
}

/* --- Lösungsfelder und Selbstkontrolle (Phase 6.2/6.3) --- */

.ab-solution-text {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 6mm;
  box-sizing: border-box;
}

.ab-solution-underline {
  border-bottom: 0.3mm solid currentColor;
}

.ab-solution-box {
  border: 0.3mm solid currentColor;
}

.ab-solution-blank {
  display: block;
  width: 100%;
  height: 100%;
}

.ab-solution-image {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  border: 0.3mm dashed #9aa3b2;
  box-sizing: border-box;
}

.ab-solution-image img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.ab-selfcheck {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  gap: 1.5mm;
  width: 100%;
  height: 100%;
}

.ab-selfcheck-entry {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 10mm;
  padding: 0.6mm 1.4mm;
  border: 0.3mm solid currentColor;
}

.ab-motif-snake {
  border-radius: 50% 20% 50% 20%;
}

.ab-motif-car {
  border-radius: 2mm 2mm 0 0;
}

.ab-motif-hedgehog {
  border-radius: 50% 50% 0 0;
}

.ab-motif-rect {
  border-radius: 0;
}

/* Stellenwertfarben (Phase 6.4) */
.ab-place {
  display: inline;
}

/* --- Mathematikfelder (Phase 6.1) --- */

.ab-math {
  width: 100%;
}

.ab-frame {
  display: flex;
  flex-direction: column;
  gap: 1.5mm;
  align-items: center;
}

.ab-frame-grid {
  display: grid;
  gap: 0.6mm;
  border: 0.4mm solid currentColor;
  padding: 0.6mm;
}

.ab-frame-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  aspect-ratio: 1;
  min-width: 4mm;
  border: 0.2mm solid #9aa3b2;
}

.ab-frame-gap {
  margin-right: 1mm;
}

.ab-dot {
  width: 70%;
  height: 70%;
  border-radius: 50%;
  position: relative;
}

.ab-dot-crossed {
  background: none !important;
  border: 0.3mm solid currentColor;
}

.ab-dot-crossed::before,
.ab-dot-crossed::after {
  content: '';
  position: absolute;
  inset: -10%;
  border-top: 0.3mm solid currentColor;
  top: 50%;
}

.ab-dot-crossed::before {
  transform: rotate(45deg);
}

.ab-dot-crossed::after {
  transform: rotate(-45deg);
}

.ab-frame-task {
  display: flex;
  gap: 1.2mm;
  margin: 0;
}

.ab-chart {
  display: grid;
  gap: 0.3mm;
}

.ab-chart-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0.25mm solid currentColor;
  min-width: 0;
  min-height: 0;
  font-size: 0.7em;
}

.ab-numberline {
  overflow: visible;
}

.ab-clocks {
  display: flex;
  gap: 4mm;
  justify-content: center;
}

.ab-clock {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1mm;
}

.ab-clock-face {
  width: 28mm;
  height: 28mm;
}

.ab-clock-text {
  margin: 0;
}

.ab-triangle {
  width: 100%;
  height: 100%;
}

.ab-chain-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0;
}

.ab-chain-part {
  display: flex;
  align-items: center;
}

.ab-chain-arrow {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 1mm;
  font-size: 0.8em;
}

.ab-chain-op {
  line-height: 1;
}

.ab-table {
  border-collapse: collapse;
}

.ab-table th,
.ab-table td {
  border: 0.3mm solid currentColor;
  padding: 0;
  text-align: center;
}

.ab-table th {
  background: #f1f3f7;
}

.ab-written {
  border-collapse: collapse;
  margin-left: auto;
  font-variant-numeric: tabular-nums;
}

.ab-written td {
  width: 6mm;
  text-align: center;
  padding: 0 0.4mm;
}

.ab-written .ab-carry td {
  font-size: 0.65em;
  color: #6b7280;
}

.ab-written-result td {
  border-top: 0.4mm solid currentColor;
}

.ab-written-sign {
  width: 4mm;
  text-align: right;
}

.ab-partial-task {
  margin: 0 0 1mm;
}

.ab-partial-steps {
  margin: 0;
  padding-left: 5mm;
}

.ab-decomposition-row {
  display: flex;
  flex-wrap: wrap;
  gap: 2mm;
  margin: 0 0 1mm;
}

.ab-decomposition-steps {
  color: #4b5563;
  font-size: 0.9em;
  margin-left: 6mm;
}

.ab-decomposition-row > span[data-slot] { display: inline-block; min-width: 12mm; }
.ab-decomposition-steps span[data-slot] { display: inline-block; min-width: 9mm; }

.ab-comparison {
  display: flex;
  flex-direction: column;
  gap: 1mm;
}

.ab-comparison-row {
  display: flex;
  align-items: center;
  gap: 2mm;
}

.ab-comparison-side {
  min-width: 10mm;
  text-align: right;
}

/* --- Text-Effekte (Phase 5.2) --- */

.ab-syllable {
  display: inline-block;
  border-bottom: 0.3mm solid currentColor;
  border-radius: 0 0 50% 50%;
  padding-bottom: 0.4mm;
}

.ab-vowel-dot {
  position: relative;
}

.ab-vowel-dot::before {
  content: '';
  position: absolute;
  left: 50%;
  top: -0.2em;
  width: 0.14em;
  height: 0.14em;
  border-radius: 50%;
  background: currentColor;
  transform: translateX(-50%);
}

.ab-outline {
  /* Nur Striche: Umriss in der Textfarbe, Fläche bleibt leer.
     Die Farbe setzt der Renderer, damit sie auch im Druck sicher steht. */
  -webkit-text-stroke-width: 0.05em;
}

.ab-mirrored {
  display: inline-block;
  transform: scaleX(-1);
}

.ab-gap-line {
  border-bottom: 0.3mm solid currentColor;
}

.ab-gap-box {
  border: 0.3mm solid currentColor;
  min-height: 1em;
}

.ab-gap-dots {
  border-bottom: 0.3mm dotted currentColor;
}

.ab-solution-words {
  margin: 1mm 0 0;
  font-size: 0.85em;
}

.ab-write-line {
  margin: 2mm 0 0;
  border-bottom: 0.3mm solid currentColor;
  min-height: 6mm;
}

/* --- Wortsuchrätsel und Schüttelwort (Phase 5.3/5.4) --- */

.ab-wordsearch {
  display: flex;
  flex-direction: column;
  gap: 1.5mm;
}

.ab-wordsearch-grid {
  display: grid;
  justify-items: center;
  align-items: center;
  flex: 1;
}

.ab-wordsearch-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  line-height: 1;
}

.ab-wordsearch-words {
  display: flex;
  flex-wrap: wrap;
  gap: 1mm 3mm;
  margin: 0;
  font-size: 0.85em;
}

.ab-wordsearch-first {
  color: #6b7280;
}

.ab-lettercloud {
  position: relative;
  width: 100%;
  height: 100%;
}

.ab-cloud-piece {
  position: absolute;
  white-space: nowrap;
}

.ab-cloud-first {
  text-decoration: underline;
}

.ab-cloud-solution {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 0;
  text-align: center;
  font-size: 0.9em;
}

/* --- Aufgabenfelder (Phase 3.2) --- */

.ab-task {
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

.ab-task-rows,
.ab-task-wall,
.ab-task-house {
  display: flex;
  flex-direction: column;
  gap: 1mm;
  width: 100%;
}

.ab-task-wall,
.ab-task-house {
  align-items: center;
}

.ab-task-row {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  gap: 1mm;
}

.ab-task-rows { gap: 0; }

.ab-task-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  text-align: center;
  line-height: 1;
}

.ab-mode-digital [data-slot] { min-height: 6mm; }
.ab-digital-choice-slot { display: inline-block; width: 34mm; height: 9mm; }
.ab-mode-digital .ab-matching { grid-template-columns: 1fr 36mm 1fr; }
.ab-matching-answers { display: flex; flex-direction: column; justify-content: space-around; }
.ab-matching-answers span { display: block; width: 34mm; height: 8mm; }
.ab-payment-slot { display: inline-block; width: 90mm; min-height: 9mm; font-size: 0.6em; }
.ab-phonics-cell svg { width: 14mm; height: 14mm; flex: none; }
.ab-clock-inputs { display: flex; gap: 2mm; font-size: 0.65em; }
.ab-clock-inputs span { display: inline-block; min-width: 12mm; min-height: 7mm; }

.ab-task-box {
  border: 0.3mm solid currentColor;
}

.ab-task-line {
  border-bottom: 0.3mm solid currentColor;
}

.ab-task-plain {
  border: none;
}

.ab-task-roof {
  display: flex;
  justify-content: center;
  margin-bottom: 1mm;
}

.ab-task-floors {
  display: flex;
  flex-direction: column;
  gap: 1mm;
}

.ab-task-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0.3mm dashed #9aa3b2;
  background: #f6f8fc;
  font-family: system-ui, sans-serif;
  font-size: 9pt;
  color: #6b7280;
}

/* --- Seitenrahmen (Phase 2.9) --- */

.ab-frame {
  position: absolute;
  inset: 0;
  pointer-events: none;
}

.ab-frame-header,
.ab-frame-footer {
  position: absolute;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
}

.ab-frame-header {
  top: 0;
}

.ab-frame-footer {
  bottom: 0;
  justify-content: flex-end;
}

.ab-frame-row {
  display: flex;
  align-items: center;
  gap: 6mm;
}

.ab-frame-field {
  display: flex;
  align-items: baseline;
  gap: 1.5mm;
  flex: 1;
}

.ab-frame-line {
  flex: 1;
  border-bottom: 0.3mm solid currentColor;
  min-width: 25mm;
  height: 0.8em;
}

.ab-frame-line-short {
  display: inline-block;
  min-width: 12mm;
  flex: none;
}

.ab-frame-title {
  font-weight: 700;
  flex: 1;
}

.ab-frame-page {
  margin-inline-start: auto;
}

.ab-frame-assessment {
  display: flex;
  gap: 2mm;
  font-size: 1.4em;
  margin-inline-start: auto;
}

.ab-frame-image {
  max-height: 9mm;
  max-width: 25mm;
}

.ab-frame-rule {
  border-top-style: solid;
}

.ab-frame-block-rule {
  position: absolute;
  left: 0;
  right: 0;
  border-top-style: dashed;
}

.ab-frame-points {
  position: absolute;
  right: 0;
  display: flex;
  flex-direction: column;
  border-left-style: solid;
}

.ab-frame-points span {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 1mm;
}

.ab-frame-sum {
  display: flex;
  align-items: baseline;
  gap: 1.5mm;
  margin-inline-start: auto;
}
`;
/** Zusätzlicher Stil nur für die Druckansicht (eine Seite je Blatt). */
export const PRINT_CSS = `
@page {
  margin: 0;
}

html,
body {
  margin: 0;
  padding: 0;
  background: #fff;
}

.ab-print {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.ab-print .ab-sheet {
  break-after: page;
  page-break-after: always;
}

.ab-print .ab-sheet:last-child {
  break-after: auto;
  page-break-after: auto;
}

.ab-attribution {
  position: absolute;
  left: 0;
  right: 0;
  bottom: -6mm;
  margin: 0;
  font-family: system-ui, sans-serif;
  font-size: 6pt;
  color: #6b7280;
  text-align: center;
}

@media screen {
  .ab-print {
    gap: 8mm;
    padding: 8mm 0;
    background: #e9ebef;
  }

  .ab-print .ab-sheet {
    box-shadow: 0 1px 6px rgb(0 0 0 / 25%);
  }
}
`;
/** Beschnittzugabe für den Profidruck in mm (Phase 4.1). */
export const BLEED_MM = 3;
/**
 * Seitengröße für den PDF-Druck. Chromium übernimmt mit `preferCSSPageSize`
 * genau dieses Maß, damit Ränder und Linien stimmen (Phase 4.1). Mit
 * Beschnittzugabe wächst die Seite um 3 mm je Kante; Schnittmarken zeigen das
 * Endformat.
 */
export function pageCss(setup, bleed = false) {
    const sheet = sheetSize(setup);
    const extra = bleed ? BLEED_MM * 2 : 0;
    const width = round1(sheet.width + extra);
    const height = round1(sheet.height + extra);
    return `
@page {
  size: ${width}mm ${height}mm;
  margin: 0;
}

.ab-print .ab-sheet {
  width: ${round1(sheet.width)}mm;
  height: ${round1(sheet.height)}mm;
}

@media print {
  .ab-print {
    gap: 0;
    padding: 0;
  }

  .ab-print .ab-sheet {
    margin: ${bleed ? `${BLEED_MM}mm` : '0'};
  }
}

.ab-crop-mark {
  position: absolute;
  width: ${BLEED_MM}mm;
  height: ${BLEED_MM}mm;
  border: 0 solid #000;
  pointer-events: none;
}

.ab-crop-mark[data-corner='tl'] {
  top: -${BLEED_MM}mm;
  left: -${BLEED_MM}mm;
  border-left-width: 0.2mm;
  border-top-width: 0.2mm;
}

.ab-crop-mark[data-corner='tr'] {
  top: -${BLEED_MM}mm;
  right: -${BLEED_MM}mm;
  border-right-width: 0.2mm;
  border-top-width: 0.2mm;
}

.ab-crop-mark[data-corner='bl'] {
  bottom: -${BLEED_MM}mm;
  left: -${BLEED_MM}mm;
  border-left-width: 0.2mm;
  border-bottom-width: 0.2mm;
}

.ab-crop-mark[data-corner='br'] {
  bottom: -${BLEED_MM}mm;
  right: -${BLEED_MM}mm;
  border-right-width: 0.2mm;
  border-bottom-width: 0.2mm;
}

.ab-variant {
  position: absolute;
  top: 4mm;
  right: 6mm;
  margin: 0;
  font-family: system-ui, sans-serif;
  font-size: 8pt;
  color: #6b7280;
}
`;
}
function round1(value) {
    return Math.round(value * 10) / 10;
}
//# sourceMappingURL=styles.js.map